import { HttpClient } from "@angular/common/http";
import { Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { tap } from "rxjs/operators";
import { IAthleteEditorialBiography } from "./athlete-biography-store";
import { CountryDependencyEntityStore } from "./country-dependency-entity-store";
import { EntitiesStore } from "./entities-store.abstract";

/**
 * The store for the Drupal API that contains WYSIWYG information about the quote for athlete.
 *
 * @export
 * @class AthleteQuotesStore
 * @extends {EntitiesStore<IAthleteEditorialBiography>}
 */
export class AthleteQuotesStore extends EntitiesStore<IAthleteEditorialBiography> {

  /**
   * Creates an instance of AthleteQuotesStore.
   * @param {HttpClient} http The http client from Angular.
   * @param {Injector} injector The injector from Angular.
   * @param {string} athleteId The athlete id.
   * @memberof AthleteQuotesStore
   */
  constructor(http: HttpClient, injector: Injector, public athleteId: string) {
    super(null, http, [{ entity: new CountryDependencyEntityStore(http, injector), params: { 'RBP': 'ALL' } }]);
  }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteQuotesStore
   */
  getRequest(params: any, request_more: boolean) {
    // tslint:disable-next-line:max-line-length
    return this.http.get<IAthleteEditorialBiography[]>(environment.editorial_quotes
      , { params: Object.assign(params, { athlete_id: this.athleteId }) }
    )
      .pipe(
        tap((a: any) => {
          this.data = a;
          this.dataStream.next(this.data);
        })
      ) as any;
  }
}
